var map = {
	"./calendar.svg": 6762,
	"./close.svg": 9335,
	"./delete.svg": 1673,
	"./edit.svg": 6937,
	"./isoterma.svg": 439,
	"./left.svg": 8723,
	"./mail.svg": 6829,
	"./minus.svg": 33,
	"./move.svg": 9398,
	"./phone.svg": 5244,
	"./pin.svg": 8725,
	"./plus-btn.svg": 3328,
	"./plus.svg": 675,
	"./ref.svg": 7873,
	"./right.svg": 3334,
	"./shevron-left.svg": 4490,
	"./shevron-right.svg": 278,
	"./time.svg": 6981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;